import {Injectable} from '@angular/core';
import {CrudService} from '@ngx-ivengi/crud';
import {Drawing} from './drawing.model';

@Injectable()
export class DrawingService extends CrudService<Drawing> {
  public entityType = Drawing;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/drawing/drawing.service.ts